import React, { useState, useEffect } from 'react';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import './style.css';

export default function ScrollPage() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > window.innerHeight / 2);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div 
      className={`topBtn ${showButton ? "" : "hidden"}`} 
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    >
      <KeyboardDoubleArrowUpIcon />
    </div>
  );
}
